import styled from 'styled-components'

export const PledgeNumberWrapper = styled.div`
  background-color: var(--tds-white);
  display: flex;
  padding: var(--tds-spacing-element-16) var(--tds-spacing-element-32) 0;
`

export const PledgeNumber = styled.h4`
  margin: 0 var(--tds-spacing-element-16) 0 0;
`

export const PledgeName = styled.h5`
  margin: 0;
  > :first-child {
    margin-top: 0;
  }
`
